export default "__VITE_ASSET__a20d59b6__"